<template>
  <div>{{ $options.name }}</div>
</template>

<script>

export default {
  name: "Admin-Callcentre-Queue",
  path: "queue",
  mounted() {
   this.$spark.$breadcrumbs(this.$options);
  }
};
</script>
